import { render, staticRenderFns } from "./MaterialExam.vue?vue&type=template&id=a7657774&scoped=true&"
import script from "./MaterialExam.vue?vue&type=script&lang=js&"
export * from "./MaterialExam.vue?vue&type=script&lang=js&"
import style0 from "./MaterialExam.vue?vue&type=style&index=0&id=a7657774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7657774",
  null
  
)

export default component.exports